import Api from './Api'

export default {
  getContent (sortBy, category, offset, time, gameName, dur, typeId, secCat, w, creator, tabGroup) {
    return Api().get('imgur',
      {
        withCredentials: true,
        params: {
          sortBy: sortBy,
          category: category,
          offset: offset,
          time: time,
          gameName: gameName,
          typeId: typeId,
          dur: dur,
          secCat: secCat,
          w: w,
          creator: creator,
          tabGroup: tabGroup
        }
      }
    )
  },

  getUserContent (sortBy, userId, offset, time, dur, typeId) {
    return Api().get('user/emotes',
      {
        withCredentials: true,
        params: {
          sortBy: sortBy,
          userId: userId,
          offset: offset,
          time: time,
          typeId: typeId,
          dur: dur
        }
      }
    )
  },

  uploadContent (uploadURL, videoCategory, gameName, secCat, title, context, tabGroup, santa) {
    return Api().post('imgur/submit',
      {
        uploadURL: uploadURL,
        videoCategory: videoCategory,
        gameName: gameName,
        secCat: secCat,
        title: title,
        context: context
      },
      { withCredentials: true }
    )
  },

  deleteContent (postId) {
    return Api().delete(`imgur/delete/${postId}`,
      {
        withCredentials: true
      })
  },

  // TODO: make this use value instead of markwatched2
  markWatched (postId, gameId, hide) {
    return Api().post('imgur/watched',
      {
        postId: postId,
        gameId: gameId,
        hide: hide
      },
      {
        withCredentials: true
      }
    )
  },

  markWatched2 (postId, gameId, hide) {
    return Api().post('imgur/unwatched',
      {
        postId: postId,
        gameId: gameId,
        hide: hide
      },
      {
        withCredentials: true
      }
    )
  },

  upvote (postId) {
    return Api().post('imgur/upvote',
      {
        postId: postId
      },
      { withCredentials: true }
    )
  },

  downvote (postId) {
    return Api().post('imgur/downvote',
      {
        postId: postId
      },
      { withCredentials: true }
    )
  },

  closeSubs () {
    return Api().get('imgur/end',
      { withCredentials: true })
  }
}
